import { render, staticRenderFns } from "./TasksDetailsDialog.vue?vue&type=template&id=ebb3e37c&"
import script from "./TasksDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./TasksDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TasksDetailsDialog.vue?vue&type=style&index=0&id=ebb3e37c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports